import { render, staticRenderFns } from "./GlobalSalesCard.vue?vue&type=template&id=9cb46542"
import script from "./GlobalSalesCard.vue?vue&type=script&lang=js"
export * from "./GlobalSalesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports